export default {
      id: "icon--download-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--download",
      toString: function () {
        return this.url;
      }
    }